((window) => {
  window.PayLater = {};

  const jsBirthday = document.getElementById('birthday');
  const jsRepaymentDate = document.getElementById('repayment-date');
  const jsCreditCheckBtn = document.querySelector('.js-soft-credit-check-btn');
  const jsNewTc = document.querySelector('.js-update-tc');
  const jsNewDp = document.querySelector('.js-update-dp');
  const jsCreditCheckTCWord = document.querySelector('.js-credit-check-tc-word');

  function enableButton() {
    if (document.querySelector('.vpay-progress-bar')) {
      if (window.innerWidth < 600) {
        document
          .querySelectorAll('.vpay-progress-bar')
          .forEach((item) => item.classList.remove('xs-col-2'));
        document
          .querySelectorAll('.vpay-progress-bar')
          .forEach((item) => item.classList.add('xs-col-6'));
      }
    }

    if (jsBirthday && jsRepaymentDate && jsCreditCheckBtn) {
      if (jsBirthday.value && jsRepaymentDate.value) {
        jsCreditCheckBtn.disabled = false;
        const formattedDate = jsRepaymentDate.value.split('/').reverse().join('/');
        const newDateString = new Date(formattedDate);

        const date = window.dayjs(newDateString).date();
        let ordinalDate;
        switch (true) {
          case date === 1:
          case date === 21:
          case date === 31:
            ordinalDate = `${date}st `;
            break;
          case date === 2:
          case date === 22:
            ordinalDate = `${date}nd `;
            break;
          case date === 3:
          case date === 23:
            ordinalDate = `${date}rd `;
            break;
          default:
            ordinalDate = `${date}th `;
            break;
        }

        const firstRepaymentDate = ordinalDate + window.dayjs(newDateString).format('MMM YYYY');
        const secondRepaymentDate =
          ordinalDate + window.dayjs(newDateString).add(1, 'month').format('MMM YYYY');
        const thirdRepaymentDate =
          ordinalDate + window.dayjs(newDateString).add(2, 'month').format('MMM YYYY');
        const fourthRepaymentDate =
          ordinalDate + window.dayjs(newDateString).add(3, 'month').format('MMM YYYY');
        const fifthRepaymentDate =
          ordinalDate + window.dayjs(newDateString).add(4, 'month').format('MMM YYYY');

        const repaymentDatesApi = {
          first: window.dayjs(newDateString).format('DD/MM/YYYY'),
          second: window.dayjs(newDateString).add(1, 'month').format('DD/MM/YYYY'),
          third: window.dayjs(newDateString).add(2, 'month').format('DD/MM/YYYY'),
          fourth: window.dayjs(newDateString).add(3, 'month').format('DD/MM/YYYY'),
          fifth: window.dayjs(newDateString).add(4, 'month').format('DD/MM/YYYY'),
        };

        window.PayLater.repaymentDates = repaymentDatesApi;

        const jsRepaymentDates = document.querySelectorAll('.js-repayment-date');
        const repaymentDatesArray = [
          firstRepaymentDate,
          secondRepaymentDate,
          thirdRepaymentDate,
          fourthRepaymentDate,
          fifthRepaymentDate,
        ];
        const jsRepaymentSchedule = document.querySelectorAll('.js-repayment-schedule');

        for (let i = 0; i < jsRepaymentDates.length; i += 1) {
          jsRepaymentDates[i].innerText = repaymentDatesArray[i];
          jsRepaymentSchedule[i].innerText = repaymentDatesArray[i];
        }
      }
    }
  }

  function updateTC() {
    const planStrDate = document.querySelector('.plan-created')?.getAttribute('value');
    const dateSplit = new Date(planStrDate?.split('/')?.reverse()?.join('-'));
    const planDate = window.dayjs(dateSplit)?.format('YYYY-MM-DD');
    const updateDate = window.dayjs('2023-03-18')?.format('YYYY-MM-DD');
    const updateCreditCheckWordingDate = window.dayjs('2023-03-27')?.format('YYYY-MM-DD');

    if (planDate >= updateDate) {
      if (jsNewTc) jsNewTc.classList.remove('hide__default');
      if (jsNewDp) jsNewDp.classList.remove('hide__default');
    }

    if (planDate >= updateCreditCheckWordingDate) {
      if (jsCreditCheckTCWord) jsCreditCheckTCWord.innerText = 'will';
    }
  }

  window.datePickerInstance = window.flatpickr('#repayment-date', {
    dateFormat: 'd/m/Y',
    inline: false,
    minDate: new Date().fp_incr(1),
    maxDate: new Date().fp_incr(44),
    disableMobile: 'true',
  });

  window.datePickerInstance = window.flatpickr('#birthday', {
    dateFormat: 'd/m/Y',
    inline: false,
    disableMobile: 'true',
  });

  vm.onload(() => {
    updateTC();
    enableButton();
  });

  window.enableButton = enableButton;
})(window);
